/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Status_ActiveInputs */

const en_branches_status_active = /** @type {(inputs: Branches_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const pt_br2_branches_status_active = /** @type {(inputs: Branches_Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativa`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Branches_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_status_active = /** @type {((inputs?: Branches_Status_ActiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Status_ActiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_status_active(inputs)
	return pt_br2_branches_status_active(inputs)
});